import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import './service/org-service'
import './plugins/filters'
import './plugins/components'
import router from './router'
import store from './store'
import './assets/stylus/reset.styl'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Element, { size: 'small', zIndex: 3000 })
Vue.config.productionTip = false
Vue.prototype.$splitImage = function(str) {
  return str ? str.split(',').map(url => ({ url, type: 'image', mediaType: /(\.mp4)$/g.test(url) ? 2 : 1, name: url.replace(/.*\?originalfilename=(.*)/g, '$1') })) : []
}

Vue.prototype.$stringfyImage = function(list) {
  return Array.isArray(list) ? list.map(i => i.url).join(',') : ''
}

Vue.prototype.$$formatTimeRange = (time, prop = '', suffix = 'Date') => {
  const [begin, end] = time || [null, null]
  return {
    [`begin${prop}${suffix}`]: begin ? +moment(begin).startOf('days') : null,
    [`end${prop}${suffix}`]: end ? +moment(end).endOf('days') : null
  }
}
Vue.prototype.$$formatTimeRange1 = (time, prop = '') => {
  const [begin, end] = time || [null, null]
  return {
    [`${prop}Start`]: begin ? +moment(begin).startOf('days') : null,
    [`${prop}End`]: end ? +moment(end).endOf('days') : null
  }
}

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
